/**
 * @generated SignedSource<<d204c628bb03fd5b7c4ba42435af08a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeliveryOrderId_deliveryOrderQuery$variables = {
  id: string;
};
export type DeliveryOrderId_deliveryOrderQuery$data = {
  readonly deliveryOrder: {
    readonly created: any;
    readonly createdBy: {
      readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
    };
    readonly deliveryAddress: {
      readonly " $fragmentSpreads": FragmentRefs<"DeliveryAddressDescriptionList_deliveryAddress">;
    };
    readonly deliveryWaybill: {
      readonly " $fragmentSpreads": FragmentRefs<"DeliveryWaybillDescriptionList_deliveryWaybill">;
    } | null;
    readonly description: string | null;
    readonly id: string;
    readonly stuff: {
      readonly id: string;
      readonly title: string;
    };
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder" | "DeliveryOrderMutationActionsButtonStack_deliveryOrder" | "DeliveryOrderStatusLabel_deliveryOrder">;
  };
};
export type DeliveryOrderId_deliveryOrderQuery = {
  response: DeliveryOrderId_deliveryOrderQuery$data;
  variables: DeliveryOrderId_deliveryOrderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Stuff",
  "kind": "LinkedField",
  "name": "stuff",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = [
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeliveryOrderId_deliveryOrderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliveryOrder",
        "kind": "LinkedField",
        "name": "deliveryOrder",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserAvatarText_user"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliveryAddress",
            "kind": "LinkedField",
            "name": "deliveryAddress",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DeliveryAddressDescriptionList_deliveryAddress"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliveryWaybill",
            "kind": "LinkedField",
            "name": "deliveryWaybill",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DeliveryWaybillDescriptionList_deliveryWaybill"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DeliveryOrderStatusLabel_deliveryOrder"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DeliveryOrderMutationActionsButtonStack_deliveryOrder"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeliveryOrderId_deliveryOrderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliveryOrder",
        "kind": "LinkedField",
        "name": "deliveryOrder",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliveryAddress",
            "kind": "LinkedField",
            "name": "deliveryAddress",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recipientNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recipientName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressDetail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zipCode",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliveryWaybill",
            "kind": "LinkedField",
            "name": "deliveryWaybill",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pickUpAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "waybillNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "senderNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pickUpStore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "boxType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "innerCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "basicFee",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "extraFee",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalFee",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "DeliveryOrderHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DeliveryOrderHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DeliveryOrderHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v2/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "address",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "addressDetail",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "zipCode",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "recipientName",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "recipientNumber",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "stuffTitle",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "DeliveryOrderDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10)"
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "873856d6586544b2364c0f6934070a55",
    "id": null,
    "metadata": {},
    "name": "DeliveryOrderId_deliveryOrderQuery",
    "operationKind": "query",
    "text": "query DeliveryOrderId_deliveryOrderQuery(\n  $id: ID!\n) {\n  deliveryOrder(id: $id) {\n    id\n    title\n    description\n    stuff {\n      id\n      title\n    }\n    created\n    createdBy {\n      ...UserAvatarText_user\n      id\n    }\n    deliveryAddress {\n      ...DeliveryAddressDescriptionList_deliveryAddress\n      id\n    }\n    deliveryWaybill {\n      ...DeliveryWaybillDescriptionList_deliveryWaybill\n      id\n    }\n    ...DeliveryOrderStatusLabel_deliveryOrder\n    ...DeliveryOrderMutationActionsButtonStack_deliveryOrder\n    ...DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder\n  }\n}\n\nfragment DeliveryAddressDescriptionList_deliveryAddress on DeliveryAddress {\n  recipientNumber\n  recipientName\n  address\n  addressDetail\n  zipCode\n}\n\nfragment DeliveryOrderCancelDialog_deliveryOrder on DeliveryOrder {\n  id\n}\n\nfragment DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder on DeliveryOrder {\n  histories(first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...DeliveryOrderHistoryDialog_deliveryOrderHistory\n        ...DeliveryOrderHistoryTimelineItem_deliveryOrderHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment DeliveryOrderDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on DeliveryOrderDifference {\n    description {\n      __typename\n    }\n    address {\n      __typename\n    }\n    addressDetail {\n      __typename\n    }\n    zipCode {\n      __typename\n    }\n    recipientName {\n      __typename\n    }\n    recipientNumber {\n      __typename\n    }\n    stuffTitle {\n      __typename\n    }\n    title {\n      __typename\n    }\n  }\n}\n\nfragment DeliveryOrderDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on DeliveryOrderDifference {\n    description {\n      ...DiffItem_diff\n    }\n    address {\n      ...DiffItem_diff\n    }\n    addressDetail {\n      ...DiffItem_diff\n    }\n    zipCode {\n      ...DiffItem_diff\n    }\n    recipientName {\n      ...DiffItem_diff\n    }\n    recipientNumber {\n      ...DiffItem_diff\n    }\n    stuffTitle {\n      ...DiffItem_diff\n    }\n    title {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment DeliveryOrderHistoryDialog_deliveryOrderHistory on DeliveryOrderHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...DeliveryOrderDifferenceCounterLabel_difference\n    ...DeliveryOrderDifferenceItemList_difference\n  }\n}\n\nfragment DeliveryOrderHistoryTimelineItem_deliveryOrderHistory on DeliveryOrderHistory {\n  id\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  created\n  type\n}\n\nfragment DeliveryOrderMutationActionsButtonStack_deliveryOrder on DeliveryOrder {\n  id\n  actions\n  ...DeliveryOrderUpdateDialog_deliveryOrder\n  ...DeliveryOrderCancelDialog_deliveryOrder\n}\n\nfragment DeliveryOrderStatusLabel_deliveryOrder on DeliveryOrder {\n  status\n}\n\nfragment DeliveryOrderUpdateDialog_deliveryOrder on DeliveryOrder {\n  id\n  type\n  description\n  title\n  stuff {\n    id\n  }\n  deliveryAddress {\n    recipientName\n    recipientNumber\n    address\n    addressDetail\n    zipCode\n    id\n  }\n}\n\nfragment DeliveryWaybillDescriptionList_deliveryWaybill on DeliveryWaybill {\n  pickUpAt\n  waybillNumber\n  sender\n  senderNumber\n  pickUpStore\n  paymentType\n  boxType\n  count\n  innerCount\n  basicFee\n  extraFee\n  totalFee\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "7996899c0f6c35c0cfceae72fb22ec16";

export default node;
